const RETENTION_CHECKOUT_PENDING_KEY = 'rs_retention_checkout_pending'

export function readRetentionCheckoutPending(): string | null {
  try {
    return localStorage.getItem(RETENTION_CHECKOUT_PENDING_KEY)
  }
  catch {
    return null
  }
}

export function markRetentionCheckoutPending() {
  try {
    localStorage.setItem(RETENTION_CHECKOUT_PENDING_KEY, 'true')
  }
  catch {}
}

export function clearRetentionCheckoutPending() {
  try {
    localStorage.removeItem(RETENTION_CHECKOUT_PENDING_KEY)
  }
  catch {}
}
